export default "__VITE_ASSET__mN7jO0O$__"